import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Icon,
} from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { useSuperAdminContext } from "../providers/SuperAdminProvider";

export const Analytics: React.FC = () => {
  const { analyticsData, fetchAnalytics } = useSuperAdminContext();

  useEffect(() => {
    if (fetchAnalytics) {
      fetchAnalytics();
    }
  }, [fetchAnalytics]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Analytics & Reports
      </Typography>

      <Grid container spacing={3}>
        {/* Revenue Trends */}
        <Grid item xs={12} lg={8}>
          <Card>
            <CardHeader
              title="Revenue Trends"
              subheader="Monthly revenue analysis"
              avatar={<Icon>trending_up</Icon>}
            />
            <CardContent>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={analyticsData?.revenueTrends}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="revenue"
                      stroke="#8884d8"
                      activeDot={{ r: 8 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Subscription Distribution */}
        <Grid item xs={12} lg={4}>
          <Card>
            <CardHeader
              title="Subscription Types"
              subheader="Distribution by plan"
              avatar={<Icon>pie_chart</Icon>}
            />
            <CardContent>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={analyticsData?.subscriptionDistribution}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="plan" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="count" fill="#82ca9d" />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* User Growth */}
        <Grid item xs={12}>
          <Card>
            <CardHeader
              title="Business Growth"
              subheader="New businesses over time"
              avatar={<Icon>group_add</Icon>}
            />
            <CardContent>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={analyticsData?.userGrowth}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="totalUsers"
                      stroke="#82ca9d"
                    />
                    <Line
                      type="monotone"
                      dataKey="activeUsers"
                      stroke="#8884d8"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
